import React from 'react'

export default function QuickStart() {
  return (
    <>
        <h1 className='mt-4'>Get Started </h1>
        <p> This documentation provides a detailed explanation by component, any extra feature is documented under Extra Styles </p>
        <p> This library is really easy to use. You can either: </p>
        <ul className='m-items-1'>
            <li> Download from <a href='/atife.zip' download='atife' className='m-0 p-0 c-blue bold m-0 p-0'>here</a>, unzip the folder, and link it in your code; Or</li>
            <li> Add this link right into your code (Note: this will require internet connection)</li>
        </ul>

        <h2 className='mt-3'>CDN link</h2>
        <p>Add this in your head tag before other stylesheets</p>
        <div className='border-grey p-1 border-curve flex-align-xy mb-2'>
            <code>
                &lt;link rel="stylesheet" href="https://atife-design.netlify.app/atife/atife.css"&gt;
            </code>
        </div>

        <p>The Javascript is currently only needed for the following classes: Accordion, Modal, Collapsible Navbars and Sidebars</p>
        <p>Add this in right before the &lt;/body&gt; tag</p>
        <div className='border-grey p-1 border-curve flex-align-xy'>
            <code>
                &lt;script src="https://atife-design.netlify.app/atife/atife.js"&gt;&lt;/script&gt;
            </code>
        </div>

        <h2 className='mt-3'>Adding to React Applications</h2>
        <p>After downloading the library, place it within your react app and add the line below in your index.js. In this example it was placed in the folder file as index.js which is 'src folder'</p>
        <div className='border-grey p-1 border-curve flex-align-xy mb-2'>
            <code>
                import './atife/atife.css';
            </code>
        </div>

        <p>The Javascript is currently only needed for the following classes: Accordion, Modal, Collapsible Navbars and Sidebars</p>
        <p>After downloading the library, place it within your react app and add the line below in your index.js. In this example it was placed in the folder file as index.js which is 'src folder'</p>
        <div className='border-grey p-1 border-curve flex-align-xy'>
            <code>
                import './atife/atife.js';
            </code>
        </div>
    </>
  )
}
